import { __assign, __awaiter, __generator, __rest } from "tslib";
import { SignatureV4 } from "@aws-sdk/signature-v4";
import { SHA256_HEADER, UNSIGNED_PAYLOAD } from "./constants";

var S3RequestPresigner =
/** @class */
function () {
  function S3RequestPresigner(options) {
    var resolvedOptions = __assign({
      // Allow `signingName` because we want to support usecase of supply client's resolved config
      // directly. Where service equals signingName.
      service: options.signingName || options.service || "s3",
      uriEscapePath: options.uriEscapePath || false
    }, options);

    this.signer = new SignatureV4(resolvedOptions);
  }

  S3RequestPresigner.prototype.presign = function (requestToSign, _a) {
    if (_a === void 0) {
      _a = {};
    }

    var _b = _a.unsignableHeaders,
        unsignableHeaders = _b === void 0 ? new Set() : _b,
        options = __rest(_a, ["unsignableHeaders"]);

    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_c) {
        unsignableHeaders.add("content-type");
        requestToSign.headers[SHA256_HEADER] = UNSIGNED_PAYLOAD;
        return [2
        /*return*/
        , this.signer.presign(requestToSign, __assign({
          expiresIn: 900,
          unsignableHeaders: unsignableHeaders
        }, options))];
      });
    });
  };

  return S3RequestPresigner;
}();

export { S3RequestPresigner };